<template>
  <div id="app">
    <router-view ></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
    }
  },
  components: {

  },
  methods: {

  },
  mounted:function(){
     // this.getConfigJson();
	}
}
</script>

<style lang="less">
#app {
  font-family: 'Avenir', 'Helvetica', 'Arial', 'sans-serif','PingFang SC';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

</style>



// WEBPACK FOOTER //
// App.vue?3739166a